import { defineMessages } from 'react-intl'

const scope = 'procurify.components.DataTable.components.APItemAccountCodeCell'

export default defineMessages({
  missingCostAllocationMessage: {
    id: `${scope}.missingCostAllocationMessage`,
    defaultMessage: 'Bill item is missing cost allocations.',
  },
  missingCostAllocationWarningIconAriaLabel: {
    id: `${scope}.missingCostAllocationWarningIconAriaLabel`,
    defaultMessage: 'Unassigned cost allocation warning',
  },
  multipleAccountText: {
    id: `${scope}.multipleAccountText`,
    defaultMessage: 'Multiple',
  },
})
